<template>
  <v-container
    v-if="assessments"
    class="white"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      align-center
      row
      wrap
    >
      <v-flex xs10>
        <h2>DFA Progress Report</h2>
      </v-flex>
      <v-flex
        xs2
        align-end
      >
        <v-btn
          class="mx-2 hidden-print-only"
          fab
          dark
          @click="print"
        >
          Print
        </v-btn>
      </v-flex>
      <v-flex
        v-if="client"
        class="hidden-screen-only"
        xs6
      >
        Client: {{ client.name }}
      </v-flex>
      <v-flex
        v-if="assessment"
        class="hidden-screen-only"
        xs6
      >
        {{ assessment.name }}
      </v-flex>
      <v-flex
        class="hidden-print-only"
        xs6
      >
        <v-select
          v-model="clientId"
          :items="clients"
          item-text="name"
          item-value="id"
          label="Client"
        />
      </v-flex>
      <v-flex
        class="hidden-print-only"
        xs6
      >
        <v-select
          v-model="assessmentId"
          :items="clientAssessment"
          item-text="text"
          item-value="id"
          label="Assessment"
        />
      </v-flex>
      <v-flex xs12>
        <v-data-table
          v-if="reportAssessmentItems.length > 0"
          :headers="headers"
          :items="reportAssessmentItems"
        >
          <template
            slot="headerCell"
            slot-scope="{ header }"
          >
            <span
              class="subheading font-weight-light text-success text--darken-3"
              v-text="header.text"
            />
          </template>
          <template v-slot:item.progress="{ item }">
            <v-progress-linear
              class="hidden-print-only"
              color="success"
              height="10"
              :value="item.progress"
            />
            <label class="hidden-screen-only pr-3">
              {{ item.progress }}%
            </label>
          </template>
          <template
            slot="items"
            slot-scope="{ item }"
          >
            <td>{{ item.metric }}</td>
            <td>{{ item.name }}</td>
            <td class="text-xs-right">
              <v-progress-linear
                class="hidden-print-only"
                color="success"
                height="10"
                :value="item.progress"
              />
              <label class="hidden-screen-only pr-3">
                {{ item.progress }}%
              </label>
            </td>
            <td class="text-xs-right pr-5">
              {{ item.totalRequests }}
            </td>
            <td class="text-xs-right pr-5">
              {{ item.totalResponses }}
            </td>
            <td class="text-xs-right pr-5">
              {{ item.totalSuccess }}
            </td>
            <td>{{ item.when }}</td>
            <td>{{ item.who }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import _ from 'lodash';
import assessmentItems from '../../mixins/assessmentItems';
import formatting from '../../mixins/formatting';

export default {
  mixins: [formatting, assessmentItems],
  data: () => ({
    clientId: null,
    assessmentId: null,
    headers: [
      {
        sortable: true,
        text: 'Metric',
        value: 'metric',
      },
      {
        sortable: true,
        text: 'Name',
        value: 'name',
      },
      {
        sortable: true,
        text: 'Progress',
        value: 'progress',
      },
      {
        sortable: true,
        text: 'Requests',
        value: 'totalRequests',
      },
      {
        sortable: true,
        text: 'Responses',
        value: 'totalResponses',
      },
      {
        sortable: true,
        text: 'Success',
        value: 'totalSuccess',
      },
      {
        sortable: true,
        text: 'Frequency',
        value: 'when',
      },
      {
        sortable: true,
        text: 'Responsible Role',
        value: 'who',
      },
    ],
  }),
  computed: {
    ...mapGetters('odata', ['assessments']),
    ...mapGetters('odata', ['clients']),
    ...mapGetters('odata', ['assessmentItems']),
    ...mapGetters('assessments', ['reportAssessmentItems']),
    ...mapState('assessments', ['reportMetrics']),
    client() {
      return _.find(this.clients, c => c.id === this.clientId);
    },
    assessment() {
      return _.find(this.assessments, c => c.id === this.assessmentId);
    },
  },
  watch: {
    assessmentId() {
      this.loadReportMetrics(this.assessmentId);
    },
  },
  created() {
    this.clearReportMetrics();
    this.$store.dispatch('odata/clear.assessmentItems');
    this.$store.dispatch('odata/load.assessments');
    this.$store.dispatch('odata/load.clients');
  },
  methods: {
    ...mapActions('assessments', ['clearReportMetrics', 'loadReportMetrics']),
    print() {
      window.print();
    },
  },
};
</script>
